import {analyticsLogEvent} from '../api'

type LayerAction = 'open' | 'switch' | 'close'

interface Parameters {
    /** Name of the currently active tab (e.g. the "Descrizione"/"Confezione"/"Spedizione e Resi" label). */
    tabName: string
    /** Interaction with the layer: open on first display, switch on tab change, close on dismiss. */
    action: LayerAction
}

/**
 * @name analyticsEventPdpDetailLayer
 *
 * @event
 *
 * @description
 * Tracks the PDP product-detail drawer (Descrizione / Confezione / Spedizione e Resi).
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.2.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'pdp_detail_layer', eventAction: '[TAB NAME]', eventLabel: 'open'|'switch'|'close' }`
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.tabName - Active tab name, mapped to `eventAction`.
 * @param {LayerAction} params.action - open/switch/close, mapped to `eventLabel`.
 */
export function analyticsEventPdpDetailLayer({tabName, action}: Parameters) {
    analyticsLogEvent('custom_event', {
        eventCategory: 'pdp_detail_layer',
        eventAction: tabName,
        eventLabel: action,
    })
}
